import gql from 'graphql-tag'
import DocumentsFragment from './DocumentsFragment'

export default gql`
  query GuarantorQuery($rid: Int!) {
    loan(rid: $rid, unscoped: true) {
      businesses {
        rid
        name
        borrowerType
        guarantors {
          rid
          name
          documents {
            ${DocumentsFragment}
          }
        }
        corporateGuarantors {
          rid
          name
          documents {
            ${DocumentsFragment}
          }
        }
      }
    }
  }
`
